import React, { ReactNode, useEffect, useState } from 'react';
import Button from '../../common/Button';
import { MemberDTO } from '../../../services/apiClient';
import FormField from '../../common/FormField';
import handleChange from '../../../utils/formUtils/handleChange';
import { useFormValidation, ValidationRules } from '../../../hooks/useFormValidation';
import { useMemberRegistrationTypes } from '../../../hooks/useMemberRegistrationTypeApi';
import { useMemberReferralTypes } from '../../../hooks/useMemberReferralTypeApi';

interface Props {
    member: MemberDTO;
    onChange: (updated: Partial<MemberDTO>) => void;
    onNext: () => void;
    onBack: () => void;
}

const ReferralSource: React.FC<Props> = ({ member, onChange, onNext, onBack }) => {
    const [formData, setFormData] = useState<MemberDTO>(member);

    // Define the type for dropdown options
    type DropdownOption = { value: string; label: ReactNode }; // Updated label type to ReactNode

    const validationRules: ValidationRules = {
        memberRegistrationTypeId: [{ required: true, message: 'Registration Type is required' },],
        memberReferralTypeId: [{ required: true, message: 'Referral Type is required' },],
        referredByName: [{ required: true, message: 'Referred By is required' },],
    }
    const { errors, validate } = useFormValidation<MemberDTO>(validationRules);

    const handleNext = () => {
        if (validate(formData)) {
            onNext();
        }
    };

    const { data: registrationTypesData, isLoading: isLoadingRegistrationTypes } = useMemberRegistrationTypes();
    const { data: referralTypesData, isLoading: isLoadingReferralTypes } = useMemberReferralTypes();

    return (
        <div>

            <FormField
                id="memberRegistrationTypeId"
                label="Are you registering for yourself or someone else"
                type="dropdown"
                value={formData.memberRegistrationTypeId || ''}
                onChange={(e) => handleChange(e, setFormData, onChange)}
                placeholder="Select Registered by"
                required={true}
                error={errors.memberRegistrationTypeId}
                options={(registrationTypesData || []).map((rt) => ({
                    value: rt.id ?? '',
                    label: rt.title ?? '',
                }))}
                isLoading={isLoadingRegistrationTypes}
            />

            <FormField
                id="memberReferralTypeId"
                label="How did you find out about Natshoot"
                type="dropdown"
                value={formData.memberReferralTypeId || ''}
                onChange={(e) => handleChange(e, setFormData, onChange)}
                placeholder="Select Referred by"
                required={true}
                error={errors.memberReferralTypeId}
                options={(referralTypesData || []).map((rf) => ({
                    value: rf.id ?? '',
                    label: rf.title ?? '',
                }))}
                isLoading={isLoadingReferralTypes}
            />
            <FormField
                id="referredByName"
                label="Referral Name/Reference Code"
                type="text"
                value={formData.referredByName || ''}
                onChange={(e) => handleChange(e, setFormData, onChange)}
                placeholder="e.g Facebook, Google, etc"
                required={true}
                error={errors.referredByName}
            />

            <div className="mt-4 flex justify-between w-full">
                <Button onClick={onBack} variant="secondary">
                    Back
                </Button>
                <Button onClick={handleNext} variant="primary">
                    Next
                </Button>
            </div>
        </div>
    );
};

export default ReferralSource;
